module.exports = __webpack_public_path__ + "img/binance_api_ip_2.e6e173c8.png";